import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/common-models';
import { GuestService } from 'src/app/shared/services/guest.service';

@Component({
    selector: 'app-form-select',
    templateUrl: './form-select.component.html',
    styleUrls: ['form-select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FormSelectComponent implements Field, OnInit {
  config!: FieldConfig;
  group!: UntypedFormGroup;

  compareOptionValues = (optionValue: unknown, selectedValue: unknown): boolean => {
    if (optionValue === null || optionValue === undefined || selectedValue === null || selectedValue === undefined) {
      return optionValue === selectedValue;
    }

    return String(optionValue) === String(selectedValue);
  };

  constructor(public gs: GuestService) { }

  ngOnInit() {
    this.group.controls[this.config.name].setValue(this.config.value);
  }

  selectedOption(event: unknown) {
    if (this.config.cellClick) {
      this.config.cellClick(event);
    }
  }
}

